export default __webpack_public_path__ + "admin-map-800-302d7c7150e1bda6cc917c8d690d161a.png";